import {HardBreak as HardBreakExtension} from "@tiptap/extension-hard-break";

export default class HardBreak {

    constructor() {

    }

    static create() {
        return new HardBreak();
    }

    getExtensions() {
        return [HardBreakExtension];
    }
}